import { render, staticRenderFns } from "./CommitRemind.vue?vue&type=template&id=343e41ac"
import script from "./CommitRemind.vue?vue&type=script&lang=js"
export * from "./CommitRemind.vue?vue&type=script&lang=js"
import style0 from "./CommitRemind.vue?vue&type=style&index=0&id=343e41ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports